<script setup lang='ts'>
import type { InputProps } from './Input.vue'
import { IconMinus, IconPlus } from '@iconify-prerendered/vue-ph'
import Button from '../Button/Button.vue'
import ButtonGroup from '../Button/ButtonGroup.vue'
import Input from './Input.vue'

type Props = Omit<InputProps, 'type'> & {
  incrementBy?: number
  incrementEnabled?: boolean
  hideIncrement?: boolean
  decrementBy?: number
  decrementEnabled?: boolean
  hideDecrement?: boolean
}

const {
  incrementBy = 1,
  incrementEnabled = true,
  hideIncrement = false,
  decrementBy = 1,
  decrementEnabled = true,
  hideDecrement = false,
  ...inputProps
} = defineProps<Props>()

const count = defineModel<number>({
  default: 0,
})
</script>

<template>
  <Input v-bind="inputProps" v-model.number="count" type="number">
    <template #end>
      <ButtonGroup :gap="2">
        <Button v-if="!hideDecrement" key="decrease" square size="s" :disabled="!decrementEnabled" @click="count -= decrementBy">
          <IconMinus /> {{ decrementBy > 1 ? decrementBy : '' }}
        </Button>
        <Button v-if="!hideIncrement" key="increase" square size="s" :disabled="!incrementEnabled" @click="count += incrementBy">
          <IconPlus /> {{ incrementBy > 1 ? incrementBy : '' }}
        </Button>
      </ButtonGroup>
    </template>
  </Input>
</template>

<style scoped lang="scss">
:deep(.vui-button) {
  padding-inline: 2px !important;
}

:deep(input) {
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
